import { Box, Container, Divider, Grid, Typography } from "@mui/material";
import Circle from "../components/circle";
import ColoredBox from "../components/colored-box";
import GradientBox from "../components/gradient-box";
import { useEffect, useState } from "react";
import { createApiCall } from "../api/api-service";
import Lipstick from "../assets/lipstick.png";
import Foundation from "../assets/foundation.png";
import { Link } from "react-router-dom";
import ProductCard from "../components/product-card";
import BrandCard from "../components/brand-card";

const LandingPage = () => {
  let image_obj = { 1: Lipstick, 2: Foundation };
  const [categoryList, setCategoryList] = useState();
  const [brandList, setBrandList] = useState([]);
  const [recentItemList, setRecentItemList] = useState([]);
  const fetch_category_list = async () => {
    const data = await createApiCall("GET", "inventory/fetch_category");
    setCategoryList(data);
  };
  const fetch_recent_list = async () => {
    const data = await createApiCall("GET", "inventory/fetch_recent_list");
    setRecentItemList(data);
  };
  const fetchBrandData = async () => {
    const data = await createApiCall("GET", "inventory/fetch_brands");
    setBrandList(data);
  };
  useEffect(() => {
    fetch_category_list();
    fetch_recent_list();
    fetchBrandData();
  }, []);
  return (
    <>
      <Container
        maxWidth={false}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            overflowX: "scroll",
            maxWidth: "100%",
            scrollbarWidth: "none",
          }}
        >
          {/* <Grid container spacing={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                    { categoryList && categoryList.map((items) => (
                        <Grid item key={items.id} xs={4} sm={4} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            
                            <Circle categoryUrl={'category/'+items?.category_name} text={items?.category_name} content={items?.category_url} />

                        </Grid>
                    ))}
                </Grid> */}
          {categoryList &&
            categoryList.map((items, index) => (
              <Circle
                categoryUrl={"category/" + items?.category_name}
                text={items?.category_name}
                content={image_obj[index]}
              />
            ))}
        </Box>
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Typography fontSize={"1em"} fontWeight={'bold'}>Recently Added</Typography>
            <Link to="/recently-added" style={{ textDecoration: "none" }}>
              <Typography color="#00000073"> See all</Typography>{" "}
            </Link>
          </Box>
          <Grid
            container
            sx={{ justifyContent: "space-around", marginTop: "10px" }}
          >
            {recentItemList?.map((item, index) => {
              return (
                <Grid size={{ xs: "6" }}>
                  <ProductCard
                    cardImage={item?.variant_image}
                    cardUrl={item?.variant_url}
                    cardText={item?.variant_name}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Box>
        {/* {recentItemList && <ColoredBox products={recentItemList} />} */}

        {/* <GradientBox header="Brands" headerUrl="/brand" gridItems={brandList} /> */}
        <Box sx={{width:'100%'}}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Typography fontSize={"1em"} fontWeight={'bold'}>Brands</Typography>
            <Link to="/brand" style={{ textDecoration: "none" }}>
              <Typography color="#00000073"> See all</Typography>
            </Link>
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: "10px",
              overflow: "scroll",
              marginTop: "10px",
              scrollbarWidth: "none",
              maxWidth: "100%",
            }}
          >
            {brandList.length !== 0 &&
              brandList.map((value, index) => {
                return (
                  <BrandCard
                    cardUrl={"brand/" + value?.brand_name}
                    cardText={value?.brand_name}
                    cardImage={value?.brand_image}
                  />
                );
              })}
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default LandingPage;
